@if (thumbs$ | async; as thumbs) {
  @if (thumbs.length) {
    <cx-carousel
      class="thumbs"
      [items]="$any(thumbs)"
      itemWidth="70px"
      [hideIndicators]="false"
      [template]="thumb"
    ></cx-carousel>
  }
}

<ng-template #thumb let-item="item">
  <cx-media
    cxFocusableCarouselItem
    [container]="item.container"
    tabindex="0"
    format="thumbnail"
    (focus)="openImage(item.container)"
    [class.is-active]="isActive(item.container) | async"
  >
  </cx-media>
</ng-template>
